import { render, staticRenderFns } from "./TabNavigation.vue?vue&type=template&id=06ae72fc&"
import script from "./TabNavigation.vue?vue&type=script&lang=js&"
export * from "./TabNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports